import { render } from "./HospitalDetail.vue?vue&type=template&id=b87d46bc&scoped=true"
import script from "./HospitalDetail.vue?vue&type=script&lang=js"
export * from "./HospitalDetail.vue?vue&type=script&lang=js"

import "./HospitalDetail.vue?vue&type=style&index=0&id=b87d46bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87d46bc"]])

export default __exports__